import Vue from 'vue'
import axiosIntents from '@/utils/axios-intents'

import i18n from '@/i18n'

const AVAILABLE_PAYMENT_PLATFORMS = ['stripe', 'braintree']
const isPaymentPlatformAvailable = (payment_platform) => AVAILABLE_PAYMENT_PLATFORMS.indexOf(payment_platform) > -1

const PAYMENT_PLATFORM = String(process.env.VUE_APP_PAYMENT_PLATFORM).trim().toLowerCase()

const state = {
    payment_platform: isPaymentPlatformAvailable(PAYMENT_PLATFORM)
        ? PAYMENT_PLATFORM
        : AVAILABLE_PAYMENT_PLATFORMS[0],

    payment_platform_client_secrets: {},
}

const getters = {
    payment_platform: state => state.payment_platform,
    payment_platforms: state => AVAILABLE_PAYMENT_PLATFORMS,

    paymentMethodIDByClientSecret: state => (ClientSecret) => state.payment_platform_client_secrets[ClientSecret]?.payment_method_id ?? getters.defaultPaymentMethodID,
}

const mutations = {
    savePaymentPlatformClientSecret(state, { ClientSecret, DefaultPaymentMethod }) {
        Vue.set(state.payment_platform_client_secrets, ClientSecret, {
            payment_method_id: DefaultPaymentMethod?.UUID ?? getters.defaultPaymentMethodID,
        })
    },

    resetPaymentPlatformClientSecrets(state) {
        state.payment_platform_client_secrets = {}
    },
}

const actions = {
    setupIntentClientSecret({getters}, PaymentGateway) {
        const uuid = getters.current_account_uid

        return uuid
            ? axiosIntents.post(`/customer/${ uuid }/setup-payment-method`, { PaymentGateway })
                .then(({result}) => Promise.resolve(result.SetupIntentClientSecret))
                .catch(error => Promise.reject(error))
            : Promise.reject(new Error(i18n.t('current_account_not_specified')))
    },

    confirmPayment({getters, dispatch}, payload) {
        const payment_platform = payload.payment_method_id
            ? getters.definePaymentProviderByPaymentMethodID(payload.payment_method_id)
            : getters.payment_platform

        return isPaymentPlatformAvailable(payment_platform)
            ? dispatch(`${ payment_platform }ConfirmPayment`, payload)
            : Promise.reject(new Error(i18n.t('unknown_payment_platform', { platform: payment_platform })))
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
}
